// @flow
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import Button from '../../../../components/Button'
import Input from '../../../../components/Input'
import normalizePhone from '../../../../utils/normalizePhone'

type Props = {
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function
}

class HireForm extends Component {
  props: Props

  handleSubmit = (data) => this.props.onSubmit({ client: data, type: 'hire' })

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              name="first_name"
              type="text"
              label="First Name"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          <div className="col-md-6 col-xs-12">
            <Field
              name="last_name"
              type="text"
              label="Last Name"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              name="email"
              type="email"
              label="Email"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          <div className="col-md-6 col-xs-12">
            <Field
              name="phone"
              type="phone"
              label="Cell Phone"
              component={Input}
              normalize={normalizePhone}
              style={{ marginBottom: '1rem' }}
            />
          </div>
        </div>
        <Button color="primary" disabled={submitting} animating={submitting}>
          Submit
        </Button>
      </form>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (!values.first_name) {
    errors.first_name = 'Required'
  }
  if (!values.last_name) {
    errors.last_name = 'Required'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Please enter valid email'
  }
  if (!values.phone) {
    errors.phone = 'Required'
  }
  return errors
}

export default reduxForm({
  form: 'hire',
  validate
})(HireForm)



// WEBPACK FOOTER //
// ./src/views/HireUs/components/HireForm/index.js